import {Inject, ModelEvents, Singleton} from "@denishussar/html5-game-engine";
import {BaseAdsLogic} from "./BaseAdsLogic";
import {BaseBannerLogic} from "./BaseBannerLogic";
import {CrazyGamesAdsLogic} from "../CrazyGames/CrazyGamesAdsLogic";
import {GameModel} from "../../Models/GameModel";
import {GameLogic} from "../GameLogic";
import {CrazyGamesBannerLogic} from "../CrazyGames/CrazyGamesBannerLogic";
import {ModalsManager} from "../../Common/MadalsManager/ModalsManager";
import {AzerionAdsLogic} from "../Azerion/AzerionAdsLogic";
import {AzerionBannerLogic} from "../Azerion/AzerionBannerLogic";

@Singleton
export class AdsLogic {
    public isReady: boolean = false;

    public get adsLogic(): BaseAdsLogic {
        return this._adsLogic;
    }

    public get bannerLogic(): BaseBannerLogic {
        return this._bannerLogic;
    }

    private _adsLogic: BaseAdsLogic;
    private _bannerLogic: BaseBannerLogic;

    constructor(
        @Inject private modelEvents: ModelEvents,
        @Inject private model: GameModel,
        @Inject private gameLogic: GameLogic,
        @Inject private modalsManager: ModalsManager,
    ) {
        console.warn("INITIALIZE ADS CONTROLLER", window['current_social']);

        switch (window['current_social']) {
            case "crazygames": {
                this._adsLogic = new CrazyGamesAdsLogic(
                    modelEvents,
                    model,
                    gameLogic
                );

                this._bannerLogic = new CrazyGamesBannerLogic(
                    modelEvents,
                    model,
                    this,
                    gameLogic,
                    modalsManager
                );
                this.isReady = true;
                break;
            }
            case "azerion": {
                this._adsLogic = new AzerionAdsLogic(
                    modelEvents,
                    model,
                    gameLogic
                );

                this._bannerLogic = new AzerionBannerLogic(
                    modelEvents,
                    model,
                    this,
                    gameLogic,
                    modalsManager
                );
                this.isReady = true;
                break;
            }
        }
    }
}